@if( !!markdownData ) {
<markdown [disableSanitizer]="true" (error)="onError($event)">{{markdownData}}</markdown>
}